const normalizeBaseUrl = (url: string): string => String(url || '').trim().replace(/\/+$/, '');

const normalizeApiBaseUrl = (url: string): string => {
  const normalized = normalizeBaseUrl(url);
  if (!normalized) return '/api';
  if (/^https?:\/\//i.test(normalized)) return normalized;
  return normalized.startsWith('/') ? normalized : `/${normalized}`;
};

export const API_BASE_URL = normalizeApiBaseUrl(
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '/api'
);

export const ASSETS_BASE_URL = API_BASE_URL.replace(/\/api(\/v\d+)?\/?$/i, '');

export const resolveApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

